import { useCallback } from 'react';

import { getPagePathValue, toSnakeCase } from '~/utils/Helpers';
import useAnalytics from '~/services/AnalyticsService';
import MobileMenuItem from './MobileMenuItem';
import { ANALYTICS } from '~/utils/Constants';
import { IMenuItemModel } from '../types';

const { EVENT_NAME, SCREEN_NAMES } = ANALYTICS;

function Menu({ menu, path }) {
  const { sendEvent } = useAnalytics();

  const handleClick = useCallback(
    value => {
      sendEvent(EVENT_NAME.pageClick, {
        screen_name: SCREEN_NAMES.blog,
        page_type: getPagePathValue(path),
        button_name: toSnakeCase(value),
      });
    },
    [sendEvent, path],
  );

  return (
    <>
      {Array.isArray(menu) &&
        menu.map((el: IMenuItemModel) => (
          <MobileMenuItem
            onClick={handleClick}
            title={el.title}
            href={el.path}
            key={el.path}
          />
        ))}
    </>
  );
}

export default Menu;
